export const LOCKED_PRIMARY_IDS = [
  'SaveAndClose', 'PostAndClose', 'Create', 'AddRow',
] as const

/** List chrome that defaults to More and can be pinned back to the bar. */
export const LIST_CHROME_IDS = ['View', 'Filters', 'GroupBy', 'Columns', 'Density'] as const

export type ListChromeId = (typeof LIST_CHROME_IDS)[number]

export type PinSlot = 'bar' | 'overflow'

const LOCKED_SET: ReadonlySet<string> = new Set(LOCKED_PRIMARY_IDS)
const CHROME_SET: ReadonlySet<string> = new Set(LIST_CHROME_IDS)

export function isLockedCommandId(id: string): boolean {
  return LOCKED_SET.has(id)
}

export function commandPinKey(connectionId: string, objectName: string, barId: string): string {
  return `cmd_pin:${connectionId}:${objectName}:${barId}`
}

export function defaultPinForId(id: string, pinDefault?: PinSlot): PinSlot {
  if (LOCKED_SET.has(id)) return 'bar'
  if (pinDefault !== undefined) return pinDefault
  if (id === 'Save' || id === 'Post' || id === 'Print' || id === 'ResetPassword') return 'bar'
  if (
    id === 'Delete'
    || id === 'Import'
    || id === 'Export'
    || id === 'Refresh'
    || id === 'ShowDeleted'
    || id === 'Fit'
    || CHROME_SET.has(id)
  ) return 'overflow'
  return 'bar'
}

export function parsePinPrefs(raw: string | null): { pinned: string[]; overflow: string[] } | null {
  if (raw == null) return null
  try {
    const parsed: unknown = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null
    const rec = parsed as Record<string, unknown>
    if (!Array.isArray(rec.pinned) || !Array.isArray(rec.overflow)) return null
    if (!rec.pinned.every((x) => typeof x === 'string')) return null
    if (!rec.overflow.every((x) => typeof x === 'string')) return null
    return { pinned: rec.pinned, overflow: rec.overflow }
  } catch {
    return null
  }
}

export function resolvePinSlot(
  id: string,
  pinDefault: PinSlot | undefined,
  prefs: { pinned: string[]; overflow: string[] } | null,
): PinSlot {
  if (LOCKED_SET.has(id)) return 'bar'
  if (prefs?.overflow.includes(id)) return 'overflow'
  if (prefs?.pinned.includes(id)) return 'bar'
  return defaultPinForId(id, pinDefault)
}
